var Business_Form = function(){
	
	this.start = (function(){
		for(var key in this){
			if(typeof this[key] === "function"){
				this[key]();
			}
		}
	}.bind(this))();
};
Bp = Business_Form.prototype;
(function($){

	
	Bp.file_input = function(){
		var $fileInputs = $('.business-form-field-file'),
			strBrowse = $('body').hasClass('rtl') ? 'עיון...' : 'Browse...';

		$fileInputs.each(function(){

			var $it = $(this);

			$it.wrap('<span class="l-flex l-rela business-form-field business-form-field-file-holder"></span>');
			
			$it.addClass('l-spread').css('opacity','0');

			var label_cell = document.createElement('span');
			label_cell.className = 'l-fg1-w0 l-flex f-c business-form-field-label_cell';

			$it.parent().append( label_cell );
			$it.parent().append( '<span class="l-shrink l-center business-form-field-instruct">' + strBrowse + '</span>' );

			$it.on('change', function(){
				var file = this.files[0];
				label_cell.textContent = file.name;
			})
		});
	};


	Bp.reconstruct_wpcf7_fieldset = function(){

		var $set = $('.wpcf7-form-control-wrap');

		if ( ! $set.length ) return;

		$set.each ( function(){

		});
	};

	Bp.wrap_label_around_checkbox_or_radio = function(){
		
		$('.wpcf7-list-item input[type="checkbox"],.wpcf7-list-item input[type="radio"]').each(function(){
			$(this).parent().addClass('business-form-radio-cell-js-label');
			$(this).addClass('l-obscure');
			$(this).after('<span class="business-radio-look"></span>')
		});
	};


	Bp.conditional_field = function(){
				
		var $toggles = $('.business-form input[type="radio"], .business-form input[type="checkbox"]');

		if ( ! $toggles.length ) return;
		
		$toggles.on( 'change', function(){

			$toggles.each ( function(){
				var name = $(this).parents('[data-toggle-input]').data('toggle-input'),
					el = $('[data-toggle-key="' + name + '"]');
				if ( this.checked ) {
					el.css('display','block');
				} else {
					el.css('display','none');
				}
			});
		});

	};

	Bp.limit_fields = function(){

		var $group = $('.business-form-part[data-limit]');

		if ( ! $group.length ) return;

		$group.each( function () {

			var $checkboxes = $(this).find('input[type="checkbox"]'),
				limiter = $(this).data('limit'),
				counters = [];
			
			$checkboxes.each ( function(){

				counters.push( $(this).attr('name') );

				$(this).on( 'change', function(){
					
					counters.forEach(function(key){

						var $filteredCheckboxes = $($checkboxes).filter(function(){
							return this.name === key;
						});

						$filteredCheckboxes.each ( function(){

							var $checkedFilteredCheckboxes = $($filteredCheckboxes).filter(function(){
								return this.checked;
							}),
							l = $checkedFilteredCheckboxes.length || 0;
							
							if ( ! this.checked && l >= limiter ){
								this.setAttribute( 'disabled','true');
							} else {
								this.removeAttribute( 'disabled');
							}
						});
						
					})

				});
			});

		});

	};

	Bp.change_validation_location = function(){
		
		document.addEventListener('wpcf7submit',function( event ){
			
			$('.business-form [role="group"]').each(function(){	
			
				var validationMessage = $(this).find('.wpcf7-not-valid-tip').last();
				
				var $title = $(this).find('.business-form-title,.business-form-label')
				
				if ( ! $title.find('.wpcf7-not-valid-tip').length ){
				
					$title.append( validationMessage );

				}
			
			});

		})
	};

	new Business_Form();


})(window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/business-form.js